import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const Icon = ({ children, className, light = false, ...other }) => (
	<i
		className={classnames('material-icons', styles.icon, className, { [styles.light]: light })}
		{...other}
	>
		{children}
	</i>
);

export default Icon;



// WEBPACK FOOTER //
// ./src/components/atoms/Icon/index.js